import { RegionEndpoints, AppRegion } from "./types/types";

export const getRegionEndpoint = (endpoints: RegionEndpoints, region: AppRegion = 'NA'): string => {
  return endpoints[region] || endpoints['NA'];
}